import { useSelector } from 'react-redux'
import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { SessionSelectors } from '../../store/session/selectors'
import usePath from '../../hooks/usePath'

type UnLoggedPageProps = {
  children: ReactNode
}

const allowedCallbackUrls = [
  'http://localhost:5173/callbacks/monect',
  'https://dev.sfa.monect.jp/callbacks/monect',
  'https://sfa.monect.jp/callbacks/monect',
]

function checkAllowedCallbackUrl(callbackUrl: string) {
  if (allowedCallbackUrls.includes(callbackUrl)) {
    return true
  }
  return /https:\/\/monect-sfa-web-.*-takada-yuichi\.vercel\.app\/callbacks\/monect/.test(callbackUrl)
}

export default function UnLoggedPage({ children }: UnLoggedPageProps) {
  const loggedIn = useSelector(SessionSelectors.loggedIn)
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const callbackUrl = query.get('callback-url')
  const token = useSelector(SessionSelectors.token)

  const { root } = usePath()
  if (!loggedIn) {
    return <>{children}</>
  }

  if (callbackUrl && checkAllowedCallbackUrl(callbackUrl) && token) {
    window.location.href = `${callbackUrl}?token=${token}`
    return null
  }

  return <Navigate to={root()} />
}
